import {
    Avatar, Backdrop, createTheme, Dialog, DialogContent,
    DialogContentText, DialogTitle, Grid, IconButton, List,
    ListItem, ListItemAvatar, ListItemText, MuiThemeProvider,
    TextField, Typography
} from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';
import { Add as AddIcon, Delete as DeleteIcon } from '@material-ui/icons';
import MUIDataTable from 'mui-datatables';
import { useSnackbar } from 'notistack';
import React, { useRef, useState } from 'react';
import { useFieldArray } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import AlertDialog from '../../components/ui/AlertDialog';
import ButtonUI from '../../components/ui/ButtonUI';
import { useAuth } from '../../hooks/auth';
import { MvmInvoice } from '../../interfaces/Mvm';
import AsnApi from '../../services/AsnApi';
import getDefaultGridOptions from '../../utils/componentUtils';
import { useStyles } from './Style';

type props =  any;

const ASNRemitoList: React.FC<props> = ({ control, title, name, allowAdd, allowDelete, Mvm  }) => {

    const classes = useStyles();
    const { t } = useTranslation("Mvm");
    const { t: _t } = useTranslation("General");
    const { t: it } = useTranslation("MvmInvoice");
    const { enqueueSnackbar } = useSnackbar();
    const { user } = useAuth();
    const [circularLoading, setCircularLoading] = useState(false);
    const [selectInvoiceType, setSelectInvoiceType] = useState(false);
    const [unknownTypeInvoice, setUnknownTypeInvoice] = useState<null | MvmInvoice>(null);
    const { fields: _fields, append, remove } = useFieldArray({ control, name: name });
    const fields = _fields as Record<string, any>[];
    const invoiceTypes = [ 'V', 'E', 'A', 'G', 'I', 'M', 'P', 'R'];
    const refFieldRemitoNumber = useRef<HTMLInputElement>(null)
    const refFieldExportationInvoiceNumber = useRef<HTMLInputElement>(null)
    
    const myTheme = createTheme({
        overrides: {
            MuiTableBody: {
                root: {
                    cursor: ''
                }
            }
        }
    })

    const columns = [
        {
            name: 'id',
            options: {
                display: false,
            }
        },
        {
            name: 'remitoNumber',
            label: "Número Remito",
            options: {
                setCellProps: () => ({
                    align: "left",
                }),
            }
        },
        {
            name: 'exportationInvoiceNumber',
            label: "Fatura de Exportação",

            options: {
                sort: false,
                setCellHeaderProps: () => ({
                    align: "center",
                  }),
                setCellProps: () => ({
                    align: "center"
                })    
            }
        }, 
        {
            name: "",
            options: {
                setCellProps: () => ({
                    align: "right"
                }),
                disableClick: true,
                sort: false,
                customBodyRender: (value: any, tableMeta: any, updateValue: any) => (
                    renderButtons(tableMeta.rowData[0], tableMeta.rowIndex)
                )
            }
        },
    ]

    const renderButtons = (id: any, rowIndex: any) => {
        //Se usuario acabou de incluir esta nota na lista, ela tem mvmid=0
        let justAdded = fields[rowIndex]['mvmId'] == 0;

        if ((allowAdd && justAdded) || allowDelete)
            return (
                <AlertDialog
                    dialogTitle={t("dialogDeleteTitle")}
                    dialogContentText={t("dialogDeleteContentText")}
                    cancelTextButton={t("cancelDeleteTextButton")}
                    confirmTextButton={t("confirmDeleteTextButton")}
                    confirmDialogFunction={() => removeMvmInvoiceFromList(rowIndex)}
                    Button={
                        <IconButton size='small' edge="end">
                            <DeleteIcon />
                        </IconButton>
                    }
                />
            );
        else
            return (<></>)
    }

   
    async function AddAsnRemitoToList() {

        setCircularLoading(true);
        var invoiceKeySearch = refFieldRemitoNumber.current
        if (!invoiceKeySearch)
        {
            setCircularLoading(false);
            return
        }

        var remitoNumber = String(invoiceKeySearch.value)
        var exportationInvoiceNumber = String(refFieldExportationInvoiceNumber.current?.value)
        exportationInvoiceNumber = exportationInvoiceNumber??"";

        if (remitoNumber.length != 12) {
            enqueueSnackbar("Numero Remito precisa ter 12 caracteres.", { variant: 'warning' })
            setCircularLoading(false);
            return
        }

        if (exportationInvoiceNumber.length != 12) {
            enqueueSnackbar("Fatura de Exportação precisa ter 12 caracteres.", { variant: 'warning' })
            setCircularLoading(false);
            return
        }

        var existingInvoice = false
        fields.map((field) => {
            if ((field as any).remitoNumber === remitoNumber && (field as any).exportationInvoiceNumber === exportationInvoiceNumber){
            existingInvoice = true
            }
        })

        if (existingInvoice) {
            enqueueSnackbar("Remito já adicionado", { variant: 'warning' })
            setCircularLoading(false)
            return
        }

        // var validInvoice = 
        // await AsnApi.validateInvoicesInUse(
        //     0,
        //     invoiceKey
        //   );

        var error = false;

          await AsnApi.validateRemitoInUse(0,remitoNumber,exportationInvoiceNumber)
          .then(response => {
            if(response) {
                enqueueSnackbar(it("alradyAssocieatedInvoice"), { variant: 'warning' })
                error = true;
            }
          })
          .catch(response => {
            enqueueSnackbar(it("errorValidatingInvoice"), { variant: 'warning' })
            error = true;
          })
          .finally(() => { setCircularLoading(false); });
        

        if (error)
          return;
        
          addRemitoToList({remitoNumber:remitoNumber, exportationInvoiceNumber:exportationInvoiceNumber})

        invoiceKeySearch.value = ""
        refFieldExportationInvoiceNumber.current!.value = "";

        setCircularLoading(false)
    }

    const removeMvmInvoiceFromList = (index: number) => {
        remove(index)
    }

    //Adicionar nota fiscal na lista da grid:
    function addRemitoToList(mvmInvoice:any) {
        
        mvmInvoice.id = 0; //garantir que id = 0 (nova NF inserida na lista): Se a nf veio do elog, pode ter vindo com o id_nota_Fiscal preenchido neste campo erroneamente
        append(mvmInvoice);
        enqueueSnackbar("Remito adicionado com sucesso!", { variant: 'success' });
    }

    //Usuario escolheu o tipo da nota fiscal:
    async function handleChooseInvoiceType(invoiceType: string) {
        let mvmInvoice = unknownTypeInvoice;

        if (invoiceType === 'cancel')
        {
            setSelectInvoiceType(false);
            setUnknownTypeInvoice(null);
            return;
        }

        //Preencher o tipo e incluir na lista
        if (mvmInvoice !== null)
        {
            mvmInvoice.invoiceType = invoiceType;
            addRemitoToList(mvmInvoice);
            setSelectInvoiceType(false);
        }
    }

    return (
        <Grid style={{ marginTop: 20, width: "98%", marginLeft: 10, marginBottom: 10 }}>
            <Typography className={classes.root} style={{ marginLeft: 0 }} >
                {title ? title : t("invoices")}
            </Typography>

            {!allowAdd ? <Grid /> :
                <Grid container spacing={1} style={{ marginBottom: 10 }}>
                    <Grid item >
                        <TextField
                            label={"Número Remito"}
                            name="remitoNumber"
                            type='number'
                            onKeyPress={(e) => {
                                if (e.key === 'Enter') {
                                    AddAsnRemitoToList()
                                    refFieldRemitoNumber.current?.focus()
                                }
                            }}
                            onInput={(e) => { (e.target as HTMLInputElement).value = (e.target as HTMLInputElement).value.slice(0, 12) }}
                            style={{ width: 300, marginRight: 10 }}
                            inputRef={refFieldRemitoNumber} />
                        <TextField
                        label={"Fatura de Exportação"}
                        name="exportationInvoiceNumber"
                        type='text'
                        onKeyPress={(e) => {
                            if (e.key === 'Enter') {
                                AddAsnRemitoToList()
                                refFieldExportationInvoiceNumber.current?.focus()
                            }
                        }}
                        onInput={(e) => { (e.target as HTMLInputElement).value = (e.target as HTMLInputElement).value.slice(0, 12) }}
                        style={{ width: 300 }}
                        inputRef={refFieldExportationInvoiceNumber} />
                    </Grid>

                    <Grid>
                        <ButtonUI
                            onClick={() => { AddAsnRemitoToList(); refFieldExportationInvoiceNumber.current?.focus()} }
                            color="primary"
                            variant="contained"
                            style={{ maxWidth: '40px', maxHeight: '38px', minWidth: '40px', minHeight: '38px', marginTop: 15, marginLeft: '10px' }}>
                            <AddIcon />
                        </ButtonUI>
                    </Grid>
                </Grid>
            }

            <Backdrop style={{ zIndex: 9999 }} open={circularLoading}>
                <CircularProgress color="inherit" />
            </Backdrop>
            <Typography className={classes.paper} style={{ marginLeft: 0 }} >
                {_t("totalRecords")} {fields ? fields.length : '0'}
            </Typography>
            <MuiThemeProvider theme={myTheme} >
                <MUIDataTable
                    title=""
                    data={fields}
                    columns={columns}
                    options={{
                        ...getDefaultGridOptions(_t),
                        serverSide: false,
                        pagination: false,
                        sort: false,
                        selectToolbarPlacement: "none",
                        filter: false,
                        search: false,
                        download: false,
                        print: false,
                        viewColumns: false,
                        selectableRows: 'none',
                    }}
                />
            </MuiThemeProvider>

            
            {/* Dialog de selecao do tipo da NF */ }
            <Dialog open={selectInvoiceType} scroll="body">
                <DialogTitle>{it("unknownInvoiceTypeTitle")}</DialogTitle>
                <DialogContent><DialogContentText>{it("unknownInvoiceTypeText")}</DialogContentText></DialogContent>
                <List>
                    <ListItem button key={'cancel'} onClick={() => handleChooseInvoiceType('cancel')}>
                        <ListItemAvatar>
                            <Avatar>
                            <DeleteIcon />
                            </Avatar>
                        </ListItemAvatar>
                        <ListItemText>{it("unknownInvoiceTypeCancel")}</ListItemText>
                    </ListItem>
                    {invoiceTypes.map((x) => {
                        return (
                            <ListItem button key={x} onClick={() => handleChooseInvoiceType(x)}>
                                <ListItemAvatar>
                                    <Avatar>
                                    <AddIcon />
                                    </Avatar>
                                </ListItemAvatar>
                                <ListItemText>{it("invoiceType_" + x)}</ListItemText>
                            </ListItem>
                        );
                    })}
                </List>
            </Dialog>
        </Grid>
    )
}

export default ASNRemitoList